import styles from "./styles.module.scss";

function Home() {
  return (
    <>
      <section className={styles.Container}>
        <div className={styles.bigtitle}>
          Mentions légales
        </div>

        <div className={styles.content}>
          <div className={styles.title}>
            1. Présentation du site.
          </div>
          <text>
            En vertu de l’article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l’économie numérique,
            il est précisé aux utilisateurs du site www.orgaexpert.fr l’identité des différents intervenants dans le cadre de sa réalisation et de son suivi :
          </text>
          <text>
            <b>Propriétaire</b> : Yasmine Hafsi Oueslati – SIRET XXX XXX XXX XXXXX – Rue de la mairie – 37520 La Riche<br></br>
            <b>Créateur</b> : OrgaExpert <br></br>
            <b>Responsable publication</b> : Yasmine Hafsi Oueslati – hello@orgaexpert.fr<br></br>
            Le responsable publication est une personne physique ou une personne morale.<br></br>
            <b>Webmaster</b> : Yasmine Hafsi Oueslati – hello@orgaexpert.fr<br></br>
            <b>Hébergeur</b> : OVH – 2 rue Kellermann – 59100 Roubaix<br></br>
            <b>Crédits photos</b> : Société : XB1204<br></br>
            <b>Photographes</b> : Karim Makni<br></br>
          </text>

          <div className={styles.title}>
          2. Conditions générales d’utilisation du site et des services proposés.
          </div>
          <text>
            L’utilisation du site www.orgaexpert.fr implique l’acceptation pleine et entière des conditions générales d’utilisation ci-après décrites. 
            Ces conditions d’utilisation sont susceptibles d’être modifiées ou complétées à tout moment, les utilisateurs du site www.orgaexpert.fr s
            ont donc invités à les consulter de manière régulière.
          </text>
          <text>
          Ce site est normalement accessible à tout moment aux utilisateurs. Une interruption pour raison de maintenance technique peut être toutefois décidée 
          par Yasmine Hafsi Oueslati, qui s’efforcera alors de communiquer préalablement aux utilisateurs les dates et heures de l’intervention.
          </text>
          <text>
          Le site www.orgaexpert.fr est mis à jour régulièrement par Yasmine Hafsi Oueslati. De la même façon, les mentions légales peuvent être modifiées à tout moment :
           elles s’imposent néanmoins à l’utilisateur qui est invité à s’y référer le plus souvent possible afin d’en prendre connaissance.
          </text>

          <div className={styles.title}>
          3. Description des services fournis.
          </div>
          <text>
          Le site www.orgaexpert.fr a pour objet de fournir une information concernant l’ensemble des activités de la société.
          </text>
          <text>
          Yasmine Hafsi Oueslati s’efforce de fournir sur le site www.orgaexpert.fr des informations aussi précises que possible. Toutefois, il ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour,
           qu’elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.
          </text>
          <text>
          Tous les informations indiquées sur le site www.orgaexpert.fr sont données à titre indicatif, et sont susceptibles d’évoluer. Par ailleurs, les renseignements figurant sur le site www.orgaexpert.fr ne sont pas exhaustifs. 
          Ils sont donnés sous réserve de modifications ayant été apportées depuis leur mise en ligne
          </text>

          <div className={styles.title}>
          4. Limitations contractuelles sur les données techniques.
          </div>
          <text>
          Le site Internet ne pourra être tenu responsable de dommages matériels liés à l’utilisation du site. De plus,
           l’utilisateur du site s’engage à accéder au site en utilisant un matériel récent, ne contenant pas de virus et avec un navigateur de dernière génération mis-à-jour
          </text>
          <div className={styles.title}>
          5. Propriété intellectuelle et contrefaçons.
          </div>
          <text>
          Yasmine Hafsi Oueslati est propriétaire des droits de propriété intellectuelle ou détient les droits d’usage sur tous les éléments accessibles sur le site,
           notamment les textes, images, graphismes, logo, icônes, sons, logiciels.
          </text>
          <text>
          Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, 
          sauf autorisation écrite préalable de : Yasmine Hafsi Oueslati.
          </text>
          <text>
          Toute exploitation non autorisée du site ou de l’un quelconque des éléments qu’il contient sera considérée comme constitutive d’une contrefaçon et poursuivie conformément
           aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
          </text>
          <div className={styles.title}>
          6. Limitations de responsabilité.
          
          </div>
          <text>
          Yasmine Hafsi Oueslati ne pourra être tenue responsable des dommages directs et indirects causés au matériel de l’utilisateur, lors de l’accès au site www.orgaexpert.fr, e
          t résultant soit de l’utilisation d’un matériel ne répondant pas aux spécifications indiquées au point 4, soit de l’apparition d’un bug ou d’une incompatibilité.
          </text>
          <text>
          Yasmine Hafsi Oueslati ne pourra également être tenue responsable des dommages indirects (tels par exemple qu’une perte de marché ou perte d’une chance) consécutifs à l’utilisation du site www.orgaexpert.fr.
          </text>
          <text>
          Un espace interactif est à la disposition des utilisateurs sur l’espace contact (formulaire). Yasmine Hafsi Oueslati se réserve le droit de supprimer, sans mise en demeure préalable, tout contenu déposé dans cet espace qui contreviendrait à la législation applicable en France, en particulier aux dispositions relatives à la protection des données. Le cas échéant, Yasmine Hafsi Oueslati se réserve également la possibilité de mettre en cause la responsabilité civile et/ou pénale de l’utilisateur, notamment en cas de message à caractère raciste, injurieux, diffamant, ou pornographique, quel que soit le support utilisé (texte, photographie…).
          </text>
          <div className={styles.title}>
          7. Gestion des données personnelles.         
          </div>
          <text>
          En France, les données personnelles sont notamment protégées par la loi n° 78-87 du 6 janvier 1978, la loi n° 2004-801 du 6 août 2004, l’article L. 226-13 du Code pénal et la Directive Européenne du 24 octobre 1995.
          </text>
          <text>
          A l’occasion de l’utilisation du site www.orgaexpert.fr, peuvent êtres recueillies : l’URL des liens par l’intermédiaire desquels l’utilisateur a accédé au site www.orgaexpert.fr, le fournisseur d’accès de l’utilisateur, l’adresse de protocole Internet (IP) de l’utilisateur.
          </text>
          <text>
          En tout état de cause Yasmine Hafsi Oueslati ne collecte des informations personnelles relatives à l’utilisateur que pour le besoin de certains services proposés par le site www.orgaexpert.fr. L’utilisateur fournit ces informations en toute connaissance de cause, notamment lorsqu’il procède par lui-même à leur saisie. Il est alors précisé à l’utilisateur du site www.orgaexpert.fr l’obligation ou non de fournir ces informations.
          </text>
          <text>
          Conformément aux dispositions des articles 38 et suivants de la loi 78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés, tout utilisateur dispose d’un droit d’accès, de rectification et d’opposition aux données personnelles le concernant, en effectuant sa demande écrite et signée, accompagnée d’une copie du titre d’identité avec signature du titulaire de la pièce, en précisant l’adresse à laquelle la réponse doit être envoyée.
          </text>
          <text>
          Aucune information personnelle de l’utilisateur du site www.orgaexpert.fr n’est publiée à l’insu de l’utilisateur, échangée, transférée, cédée ou vendue sur un support quelconque à des tiers. Seule l’hypothèse du rachat de Yasmine Hafsi Oueslati et de ses droits permettrait la transmission des dites informations à l’éventuel acquéreur qui serait à son tour tenu de la même obligation de conservation et de modification des données vis à vis de l’utilisateur du site www.orgaexpert.fr.
          </text>
          <text>
          Les bases de données sont protégées par les dispositions de la loi du 1er juillet 1998 transposant la directive 96/9 du 11 mars 1996 relative à la protection juridique des bases de données.
          </text>
          <div className={styles.title}>
          8. Droit applicable et attribution de juridiction.
          </div>
          <text>
          Tout litige en relation avec l’utilisation du site www.orgaexpert.fr est soumis au droit français. Il est fait attribution exclusive de juridiction aux tribunaux compétents de Paris
          </text>
          <div className={styles.title}>
          9. Les principales lois concernées.
          </div>
          <text>Loi n° 78-17 du 6 janvier 1978, notamment modifiée par la loi n° 2004-801 du 6 août 2004 relative à l’informatique, aux fichiers et aux libertés.</text>
          <text>Loi n° 2004-575 du 21 juin 2004 pour la confiance dans l’économie numérique.</text>
          <div className={styles.title}>
          10. Lexique.
          </div>
          <text>Utilisateur : Internaute se connectant, utilisant le site susnommé.</text>
          <text>Informations personnelles : « les informations qui permettent, sous quelque forme que ce soit, directement ou non, l’identification des personnes physiques auxquelles elles s’appliquent » (article 4 de la loi n° 78-17 du 6 janvier 1978).</text>
        </div>

        <img src="/images/logo.png" alt="logo" />
      </section>
    </>
  );
}

export default Home;